import React from 'react';
import SvgIcon, {
  SvgIconProps,
} from '@mui/material/SvgIcon';

export default function StickyIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.8297 17.249L11.7923 17.7885C9.90658 18.2877 8.96366 18.5373 8.22488 18.1285C7.48611 17.7196 7.23996 16.812 6.74765 14.9966L5.52926 10.504C5.03696 8.68862 4.79081 7.781 5.22371 7.06196C5.65661 6.34292 6.59951 6.09329 8.48533 5.59404L11.8189 4.71149C13.7047 4.21224 14.6476 3.96262 15.3864 4.37146C16.1252 4.78031 16.3713 5.68797 16.8636 7.50327L18.0868 12.0138C18.2962 12.7858 18.4009 13.1718 18.2858 13.5347M13.8297 17.249C14.4564 17.0831 14.4614 17.0805 14.9488 16.6623L17.2353 14.7003C17.859 14.1652 18.1708 13.8976 18.2858 13.5347M13.8297 17.249C13.8297 17.249 14.3197 13.4215 15.4167 12.9166C16.661 12.344 18.2858 13.5347 18.2858 13.5347"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M14.167 4.16774C14.1133 3.27324 13.9647 2.71017 13.5407 2.30643C12.8911 1.68803 11.8487 1.68495 9.76366 1.67878L6.078 1.66789C3.99307 1.66173 2.9506 1.65865 2.30478 2.27323C1.65897 2.8878 1.66201 3.88002 1.66809 5.86446L1.68314 10.7757C1.68922 12.7602 1.69227 13.7523 2.34186 14.3708C2.99145 14.9892 4.03392 14.9923 6.11886 14.9984L6.68621 15.0001"
        stroke="currentColor"
        strokeWidth="1.5"
        fill="none"
      />
    </SvgIcon>
  );
}
